var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2545_9782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6697 16.0156H23.3496C23.5861 16.6631 23.7153 17.3618 23.7153 18.0901V26.8587C23.7153 27.1623 23.6624 27.4537 23.5663 27.7248H27.4019C28.8347 27.7248 30.0003 26.5591 30.0003 25.1264V20.3462C30.0004 17.9584 28.0576 16.0156 25.6697 16.0156Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28507 18.0901C6.28507 17.3618 6.41427 16.6631 6.65075 16.0156H4.33067C1.94274 16.0156 0 17.9584 0 20.3463V25.1264C0 26.5592 1.16561 27.7248 2.5984 27.7248H6.43407C6.33792 27.4537 6.28507 27.1623 6.28507 26.8587V18.0901Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6523 13.7578H12.3483C9.96032 13.7578 8.01758 15.7006 8.01758 18.0885V26.8571C8.01758 27.3354 8.40535 27.7232 8.88371 27.7232H21.1168C21.5952 27.7232 21.983 27.3354 21.983 26.8571V18.0885C21.983 15.7006 20.0402 13.7578 17.6523 13.7578Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 2.27539C12.1274 2.27539 9.79102 4.61176 9.79102 7.48362C9.79102 9.43158 10.8662 11.1328 12.4539 12.0261C13.207 12.4497 14.0753 12.6918 14.9992 12.6918C15.9231 12.6918 16.7913 12.4497 17.5444 12.0261C19.1323 11.1328 20.2074 9.43152 20.2074 7.48362C20.2074 4.61182 17.871 2.27539 14.9992 2.27539Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85401 7.13086C3.70625 7.13086 1.95898 8.87813 1.95898 11.0259C1.95898 13.1736 3.70625 14.9209 5.85401 14.9209C6.39882 14.9209 6.91761 14.8081 7.38888 14.6052C8.20368 14.2544 8.87552 13.6334 9.29124 12.8556C9.58304 12.3097 9.74904 11.6869 9.74904 11.0259C9.74904 8.87819 8.00177 7.13086 5.85401 7.13086Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.145 7.13086C21.9973 7.13086 20.25 8.87813 20.25 11.0259C20.25 11.6869 20.416 12.3097 20.7078 12.8556C21.1235 13.6335 21.7954 14.2545 22.6102 14.6052C23.0814 14.8081 23.6002 14.9209 24.145 14.9209C26.2928 14.9209 28.0401 13.1736 28.0401 11.0259C28.0401 8.87813 26.2928 7.13086 24.145 7.13086Z",
    fill: "#990000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2545_9782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerRedIcon);
export default __webpack_public_path__ + "static/media/customerRedIcon.626c25c5ba0da2f1f07ecb126d581c16.svg";
export { ForwardRef as ReactComponent };